/*
(c) Copyright European Space Agency, 2023

Project name: THEMIS: Tracking the Health of the Environment and Missions in Space

Description:  Keplerian Inputs component for PMD Phase
Author: Deimos Space UK

Version: 1.0
*/

import React from 'react'
import { Row, Col, Form } from 'react-bootstrap';
import style from '../PMDPhase.module.css'
function KeplerianInputs(props) {
    return (
        <div>
            <Row className={style.manualInput} >
                <Col xs={6} md={4} >
                    <Form.Group className={style.manualInput} controlId="semiMajorAxis">
                        <Form.Label  style={{ color: '#003247' }}>Semi major axis [km]</Form.Label>
                        <Form.Control 
                        isInvalid={(isNaN(props?.step4?.semiMajorAxis) && props?.step4?.semiMajorAxis !== '') || (props?.step4?.semiMajorAxis < 6400 && props?.step4?.semiMajorAxis !== '')|| props?.step4?.semiMajorAxis > 100000}
                        disabled={props.disabled} 
                        value={props?.step4?.semiMajorAxis} 
                        onChange={e => props.changeSemiMajorAxis(e.target.value, props?.orbit)} />
                    </Form.Group>
                </Col>
                <Col xs={6} md={4} >
                    <Form.Group className={style.manualInput} controlId="eccentricity">
                        <Form.Label  style={{ color: '#003247' }} >Eccentricity</Form.Label>
                        <Form.Control
                        isInvalid={(isNaN(props?.step4?.eccentricity) && props?.step4?.eccentricity !== '') || props?.step4?.eccentricity < 0 || props?.step4?.eccentricity >= 1}
                        disabled={props.disabled} 
                        value={props?.step4?.eccentricity} 
                        onChange={e => props.changeEccentricity(e.target.value, props?.orbit)} />
                    </Form.Group>
                </Col>
                <Col xs={6} md={4} >
                    <Form.Group className={style.manualInput} controlId="inclination">
                        <Form.Label  style={{ color: '#003247' }}>Inclination [deg]</Form.Label>
                        <Form.Control 
                        isInvalid={(isNaN(props?.step4?.inclination) && props?.step4?.inclination !== '') || props?.step4?.inclination < 0 || props?.step4?.inclination > 180}
                        disabled={props.disabled} 
                        value={props?.step4?.inclination} 
                        onChange={e => props.changeInclination(e.target.value, props?.orbit)} />
                    </Form.Group>
                </Col>
                <Col xs={6} md={4} className={style.manualInput} >
                    <Form.Group controlId="longitudeOfAscendingNode">
                        <Form.Label  style={{ color: '#003247' }}>Right ascension of the ascending node [deg]</Form.Label>
                        <Form.Control
                            isInvalid={(isNaN(props?.step4?.rightAscension) && props?.step4?.rightAscension !== '') || props?.step4?.rightAscension < 0 || props?.step4?.rightAscension > 360}
                            disabled={props.disabled}
                            value={props?.step4?.rightAscension}
                            onChange={e => props.changeRightAscension(e.target.value, props?.orbit)} />
                    </Form.Group>
                </Col>

                <Col xs={6} md={4} className={style.manualInput}  >
                    <Form.Group controlId="argumentOfPeriapsis">
                        <Form.Label  style={{ color: '#003247' }}>Argument of perigee [deg]</Form.Label>
                        <Form.Control 
                        isInvalid={(isNaN(props?.step4?.argumentOfPerigee) && props?.step4?.argumentOfPerigee !== '') || props?.step4?.argumentOfPerigee < 0 || props?.step4?.argumentOfPerigee > 360}
                        disabled={props.disabled} 
                        value={props?.step4?.argumentOfPerigee} 
                        onChange={e => props.changeArgumentOfPerigee(e.target.value, props?.orbit)} />
                    </Form.Group>
                </Col>
              
                <Col xs={6} md={4} className={style.manualInput} >
                    <Form.Group controlId="inclination">
                        <Form.Label  style={{ color: '#003247' }}>Mean anomaly [deg]</Form.Label>
                        <Form.Control 
                        isInvalid={(isNaN(props?.step4?.meanAnomaly) && props?.step4?.meanAnomaly !== '') || props?.step4?.meanAnomaly < 0 || props?.step4?.meanAnomaly > 360}
                        disabled={props.disabled} 
                        value={props?.step4?.meanAnomaly} 
                        onChange={e => props.changemMeanAnomaly(e.target.value, props?.orbit)} />
                    </Form.Group>
                </Col>
            </Row>

        </div>
    )
}

export default KeplerianInputs